import { useTranslation } from "react-i18next";
import { ReactComponent as RecoEngineIcon } from "../assets/reco-engine-icon.svg";
import { useRefineForm } from "../hooks";

interface RefineFormProps {
  mode: "edit" | "display";
  questions?: string[];
  answers?: string[];
  setRefineFormData?: (data: any) => void;
  addBlock?: (block: any) => void;
}

const RefineForm = ({ 
  mode, 
  questions, 
  answers, 
  setRefineFormData, 
  addBlock 
}: RefineFormProps) => {
  const [t] = useTranslation("translations");
  
  const {
    err,
    questionsObject,
    handleSubmit,
    updateAnswer,
  } = useRefineForm({ setRefineFormData, addBlock });

  const isEditMode = mode === "edit";

  return (
    <>
      {(mode === "display" ?  questions?.length > 0 : questionsObject?.questions.length > 0) && (
        <div className="refineForm__container">
          <RecoEngineIcon />
          <form
            className="recoEngine__refineForm"
            onSubmit={(e) => {
              e.preventDefault();
              if (isEditMode) {
                handleSubmit();
              }
            }}
          >
            <h3>{t("RecoSearch.refine_form_title")}</h3>
            <p className="refineForm__desc">{t("RecoSearch.refine_form_description")}</p>
            
            {(mode === "display" ? questions : questionsObject.questions).map((question, i) => (
              <div className="refineForm__question" key={`question-${question}`}>
                <label htmlFor={`search-${i}`}>{question}</label>
                <textarea
                  id={`search-${i}`}
                  value={mode === "display" ? answers?.[i] || "" : questionsObject.answers?.[i] || ""}
                  onChange={(e) => {
                    if (isEditMode) {
                      updateAnswer(i, e.target.value);
                    }
                  }}
                  readOnly={!isEditMode}
                  placeholder={isEditMode ? "Type your answer here" : undefined}
                />
              </div>
            ))}
            
            {isEditMode && (
              <button className="recoEngine__button" type="submit">
                {t("RecoSearch.form_submit")}
              </button>
            )}
            {err && <p className="form-error">{t("RecoSearch.form_error")}</p>}
          </form>
        </div>
      )}
    </>
  );
};

export default RefineForm;